import { useNavigate } from "react-router-dom";
import { Lock, Network } from "lucide-react";

export const ProgressBar = ({ conteo, meta }) => (
  <div data-testid="red-unlock-progress" className="space-y-1.5">
    <div className="h-2 rounded-full bg-[var(--c-elev)] overflow-hidden">
      <div className="h-full bg-[#bc9538] transition-[width] duration-500" style={{ width: `${Math.min(100, (conteo / meta) * 100)}%` }} />
    </div>
    <p data-testid="red-unlock-text" className="text-xs c-text-2">Carga {meta} contactos para desbloquear la red ({Math.min(conteo, meta)} de {meta})</p>
  </div>
);

export const RedSearchButton = ({ estado, q }) => {
  const nav = useNavigate();
  if (!estado) return null;
  const locked = !estado.activado;
  return (
    <div data-testid="red-search-block" className="c-card p-3 space-y-2.5">
      <button data-testid="red-search-btn" aria-disabled={locked} onClick={() => !locked && nav(`/conecta/buscar${q ? `?q=${encodeURIComponent(q)}` : ""}`)}
        className={`w-full flex items-center justify-center gap-2 py-3 rounded-xl text-sm font-semibold transition-opacity ${locked ? "bg-[var(--c-elev)] c-muted cursor-not-allowed" : "c-btn-primary"}`}>
        {locked ? <Lock className="w-4 h-4" /> : <Network className="w-4 h-4" />} Buscar en la red
      </button>
      {locked && <ProgressBar conteo={estado.conteo} meta={estado.meta} />}
    </div>
  );
};
